import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// App bootstrap
createRoot(document.getElementById("root")!).render(<App />);
